(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('CustomDocumentsController', customDocumentsController)

  customDocumentsController.inject = ['$rootScope', '$window', 'NotificationService', 'taOptions', 'textAngularManager', 'ChatBotConfigsService', 'CustomDocumentsService', 'Upload']

  function customDocumentsController ($rootScope, $window, NotificationService, taOptions, textAngularManager, ChatBotConfigsService, CustomDocumentsService, Upload) {
    var vm = this;
    vm.page = 'view';
    vm.templateText = '';

    taOptions.toolbar = [
      ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol',
        'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent',
        'html', 'insertLink']
    ];

    loadCustomDocuments();

    function loadCustomDocuments () {
      CustomDocumentsService
        .all()
        .$promise
        .then(function (data) {
          vm.customDocuments = data;
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.errorLoadCustomDocs);
        });
    }

    vm.goToCreatePage = function () {
      vm.page = 'create';
      vm.customDoc = {};
    }

    vm.goToViewPage = function () {
      vm.page = 'view';
      loadCustomDocuments();
    }

    vm.loadChatBotParams = function () {
      ChatBotConfigsService
        .getChatBotParams({
          chatbot_path: vm.customDoc.chatbot_path
        })
        .$promise
        .then(function (data) {
          if (data && data.hasOwnProperty('configs')) {
            vm.params = data.configs.params;
          }
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.errorLoadParams);
        });
    }

    vm.addParamOnTemplate = function (key) {
      key = '${' + key + '}';

      textAngularManager.retrieveEditor('txtAreaTemplate').scope.wrapSelection('insertHTML', key, true);
      textAngularManager.retrieveEditor('txtAreaTemplate').scope.displayElements.text.trigger('focus');
    }

    vm.save = function () {
      if (vm.customDoc._id) {
        CustomDocumentsService
          .update(
            { id: vm.customDoc._id },
            vm.customDoc
          )
          .$promise
          .then(function (data) {
            vm.page = 'view';
            loadCustomDocuments();
            NotificationService.successHandler(data, $rootScope.labels.customDocsSaved);
          })
          .catch(function (error) {
            NotificationService.errorHandler(error, $rootScope.labels.errorSaveCustomDocs);
          });
      } else {
        CustomDocumentsService
          .save(vm.customDoc)
          .$promise
          .then(function (data) {
            vm.page = 'view';
            loadCustomDocuments();
            NotificationService.successHandler(data, $rootScope.labels.customDocsSaved);
          })
          .catch(function (error) {
            NotificationService.errorHandler(error, $rootScope.labels.errorSaveCustomDocs);
          });
      }
    }

    vm.edit = function (customDocId) {
      vm.page = 'create';
      CustomDocumentsService
        .findOne({
          id: customDocId
        })
        .$promise
        .then(function (data) {
          vm.customDoc = data;
          vm.loadChatBotParams();
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.errorLoadCustomDoc);
        });
    }

    vm.delete = function (customDocId) {
      var confirmation = $window.confirm($rootScope.labels.confirmDeleteCustomDoc);
      if (confirmation) {
        CustomDocumentsService
          .delete({
            id: customDocId
          })
          .$promise
          .then(function (data) {
            if (data && data.success) {
              NotificationService.successHandler(data, $rootScope.labels.customDocDeleted);
            } else {
              NotificationService.errorHandler(data, $rootScope.labels.errorDeleteCustomDoc);
            }
            loadCustomDocuments();
          })
          .catch(function (error) {
            NotificationService.errorHandler(error, $rootScope.labels.errorDeleteCustomDoc);
          });
      }
    }

    vm.uploadFile = function (file) {
      if (file) {
        file.upload = Upload.upload({
          url: apiUrl + '/custom-documents-file',
          file: file
        });

        file.upload.then(function (response) {
          if (response.hasOwnProperty('data')) {
            vm.customDoc.fileUrl = response.data.public_path;
          }
          NotificationService.successHandler(response, $rootScope.labels.customDocUploaded);
        });
      }
    }

    vm.downloadFile = function () {
      var anchor = angular.element('<a/>');
      anchor.css({ display: 'none' });
      angular.element(document.body).append(anchor);
      anchor.attr({
        href: vm.customDoc.fileUrl,
        target: '_blank'
      })[0].click();
      anchor.remove();
    }
  }
})();
